import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-jobs-view-manual',
  templateUrl: './jobs-view-manual.component.html',
  styleUrls: ['./jobs-view-manual.component.scss']
})
export class JobsViewManualComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
